/** @jsx jsx */
import { jsx } from '@emotion/core'
import styled from '@emotion/styled'
import React, { useState, useContext, useMemo, useEffect } from 'react'
import {
  unitIdHeader,
  modifierCol,
  modifiedDateCol,
} from 'core/HeaderColTypeProps'
import { dateCol, numCol, strCol } from '@integec/grid-tools/lib/cols'
import {
  retrieveCostAdjustment,
  saveCostAdjustment,
  deleteCostAdjustment,
} from 'api/pgads'
import { connect } from 'react-redux'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnits,
  hasAccesPermits,
} from 'core'
import { CriteriaRow } from 'core/screen-util'
import { Button, DatePicker, Select, InputNumber, Input } from 'antd'
import { ErrorContext, PNodeZoneContext } from 'context'
import * as Actions from 'core/EventActions'

import CommonScreen from 'admin/component/CommonScreen'

import { toSelectionColProps } from '@integec/grid-tools'

import MarginAnalysisUtilityUnitSelection from '../MarginAnalysisUtilityUnitSelection'
import {
  getPFuelCodeAtFuelUsageByClients,
  getStartFuelCodeAtStartupCostByClients,
} from 'marginanalysis/utils'

const title = 'Cost Adjustment'

const Label = styled.div`
  display: grid;
  justify-content: end;
  align-content: center;
`

const headers = [
  //   strCol({ ident: 'unitid', display: 'Unitid', isKey: true, sortOrder: 'asc' }),
  unitIdHeader,
  dateCol({
    ident: 'effectiveDate',
    display: 'Effectivedate',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
  }),
  strCol({
    ident: 'adjustmentType',
    display: 'Adjustment Type',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
    // ...toSelectionColProps(seasonChioce),
  }),
  numCol({
    ident: 'costAdjustment',
    display: 'Cost Adjustment',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
    // ...toSelectionColProps(seasonChioce),
  }),
  strCol({
    ident: 'description',
    display: 'Description',
    sortOrder: 'asc',
    width: 350,
    ellipsis: true,
    // ...toSelectionColProps(seasonChioce),
  }),
  modifierCol,
  modifiedDateCol,
]

// eslint-disable-next-line no-unused-vars
const CostAdjustment = ({ targetInfo, envConfig, actionPermits, ...props }) => {
  // const { selectedUnits } = useContext(UnitSelectionContext)
  const { setError } = useContext(ErrorContext)
  const [insertEvent, setInsertEvent] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [editMode, setEditMode] = useState(true)

  const [pFuelCodeMap, setPFuelCodeMap] = useState({})

  const [startFuelCodeMap, setStartFuelCodeMap] = useState({})

  const { unitIdEmktIdMap, marginUnitsList, emktIdUnitNameMap } = useContext(
    PNodeZoneContext
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <CriteriaRow style={{ paddingLeft: '0px' }}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '130px 100px 100px 100px 100px 100px 120px 150px auto auto',
          gridGap: '5px',
        }}
      >
        <Label>Unit:</Label>
        <div style={{ gridColumn: 'span 5' }}>
          <MarginAnalysisUtilityUnitSelection
            utility={insertData.utility || null}
            unit={insertData.unit || null}
            onUnitChange={value => {
              // setUtilityUnit(value)
              setInsertData({
                ...insertData,
                utility: value[0],
                unit: value[1],
                unitId: unitIdEmktIdMap[value[1]],
              })
            }}
            style={{ width: '100%' }}
          />
        </div>
        <Label>Effective Date:</Label>
        <DatePicker
          allowClear={false}
          format="MM/DD/YYYY"
          value={insertData.effectivedateObj}
          onChange={date => {
            setInsertData({
              ...insertData,
              effectiveDate: date.format('YYYY-MM-DD'),
              effectivedateObj: date,
            })
          }}
          style={{ width: '100%' }}
        />
        <Label>Adjustment Type :</Label>
        <Select
          value={insertData.adjustmentType}
          onChange={value =>
            setInsertData({ ...insertData, adjustmentType: value })
          }
          style={{ width: '100%' }}
        >
          <Select.Option key="DOLLAR" value="DOLLAR">
            DOLLAR
          </Select.Option>
          <Select.Option key="PERCENT" value="PERCENT">
            PERCENT
          </Select.Option>
        </Select>
        <Label>Cost Adjustment :</Label>
        <InputNumber
          value={insertData.costAdjustment}
          onChange={value =>
            setInsertData({ ...insertData, costAdjustment: value })
          }
          style={{ width: '100%' }}
        />
        <Label>Description :</Label>
        <Input
          style={{ gridColumn: 'span 5', width: '100%' }}
          value={insertData.description}
          onChange={e =>
            setInsertData({ ...insertData, description: e.target.value })
          }
          maxLength={1000}
        />

        <div
          style={{
            gridColumn: 'span 2',
            gridRowGap: '10px',
            width: '100%',
            display: 'grid',
            gridTemplateColumns: 'auto auto auto',
            paddingLeft: '5px',
            gridColumnGap: '10px',
          }}
        >
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>
          <Button type="primary" onClick={() => onAdd(false)}>
            Add & Hide
          </Button>
          <Button type="danger" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    </CriteriaRow>
  )

  useEffect(
    _ => {
      getPFuelCodeAtFuelUsageByClients({
        targetInfo,
        setError,
        setPFuelCodeMap,
        CLIENT: envConfig.clientId,
      })
      getStartFuelCodeAtStartupCostByClients({
        targetInfo,
        setError,
        setStartFuelCodeMap,
        CLIENT: envConfig.clientId,
      })
    },
    [envConfig.clientId, setError, targetInfo]
  )

  const headerWithFormatter = headers.map(header =>
    header.ident === 'unitId' || header.ident === 'unitid'
      ? {
          ...header,
          dataFormatter: ({ value }) => emktIdUnitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            emktIdUnitNameMap[rowData.unitId] ||
            emktIdUnitNameMap[rowData.unitid] ||
            rowData.unitId ||
            rowData.unitid,
        }
      : header.ident === 'pFuelCode'
      ? { ...header, ...toSelectionColProps(pFuelCodeMap) }
      : header.ident === 'startFuelCode'
      ? { ...header, ...toSelectionColProps(startFuelCodeMap) }
      : header
  )

  const writeEventActionPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          Actions.MARGIN_ANALYSIS_ADMIN,
          Actions.MARGIN_ANALYSIS_CORE_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const writePermission = useMemo(_ => writeEventActionPermission && editMode, [
    writeEventActionPermission,
    editMode,
  ])

  const withCriteria = (state, props, selectedUnits, selectedDate) => {
    return {
      date: selectedDate,
      units: (selectedUnits || [])
        .filter(e => !!e)
        .map(e => unitIdEmktIdMap[e.unitId]),
    }
  }

  // writeEventActionPermission ? (
  //   <Checkbox
  //     css={{ marginLeft: '10px', minWidth: '100px' }}
  //     onChange={e => setEditMode(e.target.checked)}
  //     checked={editMode}
  //   >
  //     Edit Mode
  //   </Checkbox>
  // ) : (
  //   <div />
  // )

  const extraUnitSelectionProps = _ => ({
    limitedUnits: marginUnitsList,
    units: marginUnitsList,
    // itemToLabel: e => e.emktId,
  })

  // const modifySaveDataBeforeSave = (saveData, validateData) => {
  //   return saveData.map(s => ({ ...s, unitId: emktUnitMap[s.unitId] }))
  // }

  // eslint-disable-next-line no-unused-vars
  const isEditableGrid = ({ header, rowData }) => {
    if (
      header.ident === 'modifier' ||
      header.ident === 'modifiedDate' ||
      header.isKey
    )
      return false

    return writePermission
  }
  // const sortOptions = [
  //   unitIdHeader,
  //   strCol({
  //     ident: 'pFuelCode',
  //     display: 'PFuel Code',
  //     isKey: true,
  //     sortOrder: 'asc',
  //     width: 150,
  //     // ...toSelectionColProps(seasonChioce),
  //   }),
  // ]

  return (
    <div>
      <CommonScreen
        // modifySaveDataBeforeSave={modifySaveDataBeforeSave}
        withoutModify={!writeEventActionPermission}
        withDelete={!writeEventActionPermission}
        allowInsert={writeEventActionPermission}
        isEditableGrid={isEditableGrid}
        extraUnitSelectionProps={extraUnitSelectionProps}
        withUnitSelection
        withDatePickerTitle="Effective Date"
        autoRetrieve={false}
        isAdminScreen={false}
        withCriteria={withCriteria}
        withDatePicker
        title={title}
        header={headerWithFormatter}
        saveTask={saveCostAdjustment}
        retrieveTask={retrieveCostAdjustment}
        deleteTask={deleteCostAdjustment}
        altBy={u => u.unitId}
        sortOptions={headers}
        initialSortOptions={headers}
        widthOffset={50}
        insertComp={insertEvent && insertComp}
        insertCompHeight={120}
        onInsertEvent={b => setInsertEvent(b)}
        defaultInsertData={{ adjustmentType: 'DOLLAR' }}
      />
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(CostAdjustment)
